import React, { useCallback, useContext, useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import GlobalContext from "../framework/GlobalContext";
import Tab from "../framework/tab/Tab";
import { configureInitialState } from "../framework/tab/tabUtils";
import images from "../assets/images";
import classes from "./Home.module.css";
import { isEmpty } from "../utils/utils";
import Spotlight from "../common/spotlight/Spotlight";
import Loading from "../common/loading/Loading";
import nodeClient, { BYPASS_ERROR_URLS } from "../services/node-client";
import { displayToast } from "../framework/toast/toastUtils";
import { initial_state_users } from "./users/constant";
import PinIcon from "@mui/icons-material/Pin";
import { Fade, IconButton, Tooltip } from "@mui/material";
import {
  CONFIGURATION_TAB,
  GENERATE_OTP_TAB,
} from "../framework/tab/tabUtilsConstants";
const Home = () => {
  const {
    tabs,
    activeTabIndex,
    configData: { SET_MAXIMUM_TABS = 10 },
  } = useSelector((state) => state.commonReducer);

  const {
    goToNextTab,
    setGoToNextTab,
    goToPrevTab,
    setGoToPrevTab,
    addNewTab,
    setAddNewTab,
    goToTab,
    setGoToTab,
    closeCurrentTab,
    setCloseCurrentTab,
    // showAddProductAutocomplete,
    // setShowAddProductAutocomplete,
    // showGlobalShortcuts,
    // setShowGlobalShortcuts,
    showSpotlight,
    setShowSpotlight,
    // setBarcode,
    showLoading,
    setShowLoading,
    setCurrentComponent,
  } = useContext(GlobalContext);

  const dispatch = useDispatch();
  const [tabList, setTabList] = useState(tabs);
  const [selectedIndex, setSelectedIndex] = useState(activeTabIndex);
  const [nextTab, setNextTab] = useState(false);
  const [prevTab, setPrevTab] = useState(false);
  const [closeTab, setCloseTab] = useState(false);
  const { spotlight, logout } = images;
  const navigate = useNavigate();
  const showSpotlightHandler = (e) => {
    setShowSpotlight(true);
  };
  const logoutHandler = useCallback(
    (e) => {
      sessionStorage.clear();
      setAddNewTab(null);
      navigate("/login");
    },
    [navigate, setAddNewTab]
  );
  const titleBarStartItems = [
    <div
      key="spotlight"
      className={classes["title-bar-icons"]}
      onClick={showSpotlightHandler}
    >
      <img src={spotlight} alt="spotlight" />
    </div>,
  ];
  const titleBarEndItems = [
    <div key="generate_otp" className={`${classes["title-bar-icons"]}`}>
      <Tooltip
        key="generate_otp"
        title={
          <div
            style={{
              display: "flex",
              gap: "2px",
              alignItems: "center",
              height: "25px",
            }}
          >
            Generate OTP
          </div>
        }
        arrow
        TransitionComponent={Fade}
        TransitionProps={{ timeout: 600 }}
      >
        <IconButton
          sx={{ padding: 0 }}
          onClick={() => setAddNewTab({ component: GENERATE_OTP_TAB })}
        >
          <PinIcon
            sx={{
              background: "#020002",
              borderRadius: "4px",
              color: "#fff",
              padding: "2px",
              fontSize: 30,
            }}
          />
        </IconButton>
      </Tooltip>
    </div>,
    <div key="logout" className={classes["title-bar-icons"]}>
      <img src={logout} alt="logout" onClick={logoutHandler} />
    </div>,
  ];

  const closeTabHandler = useCallback(
    (updated_tabs, newIndex, deleted_tab) => {
      setCloseTab(false);
      setSelectedIndex(newIndex);
      if (updated_tabs?.length === 0) {
        updated_tabs = [initial_state_users];
        setTabList(updated_tabs);
      }
      dispatch({ type: "update_tabs", payload: updated_tabs });
      dispatch({ type: "update_active_tab_index", payload: newIndex });
    },
    [dispatch]
  );

  const updatedTabsHandler = useCallback(
    (updated_tabs, newIndex) => {
      if (updated_tabs)
        dispatch({ type: "update_tabs", payload: updated_tabs });
      if (!isEmpty(newIndex)) {
        //updated by alston
        dispatch({ type: "update_active_tab_index", payload: newIndex });
      }
    },
    [dispatch]
  );

  useEffect(() => {
    if (goToNextTab) {
      setNextTab(true);
      setGoToNextTab(false);
    }
  }, [activeTabIndex, goToNextTab, setGoToNextTab, tabs]);

  useEffect(() => {
    if (goToPrevTab) {
      setPrevTab(true);
      setGoToPrevTab(false);
    }
  }, [activeTabIndex, goToPrevTab, setGoToPrevTab]);

  useEffect(() => {
    if (closeCurrentTab) {
      setCloseTab(true);
      setCloseCurrentTab(false);
    }
  }, [closeCurrentTab, setCloseCurrentTab]);

  useEffect(() => {
    if (goToTab !== null && tabs.length > goToTab) {
      setSelectedIndex(goToTab);
      setGoToTab(null);
    }
  }, [goToTab, setGoToTab, tabs]);

  useEffect(() => {
    if (addNewTab?.component) {
      if (SET_MAXIMUM_TABS === tabs.length) {
        displayToast({ type: "error", title: "Max tab limit reached." });
        setAddNewTab(null);
        return;
      }
      let updated_tabs = [...tabs];
      const new_tab = configureInitialState(addNewTab.component);
      if (new_tab?.allowMultipleTabs === false) {
        const temp_index = tabs.findIndex((t) => t.type === new_tab.type);
        if (temp_index !== -1) {
          if (new_tab.type === CONFIGURATION_TAB) {
            displayToast({
              type: "warn",
              title:
                "Configuration tab is already opened. Please close it and try again.",
            });
            setAddNewTab(null);
            return;
          }
          if (selectedIndex !== temp_index) setSelectedIndex(temp_index);
          setAddNewTab(null);
          return;
        }
      }
      updated_tabs = [
        ...updated_tabs,
        { ...new_tab, props: addNewTab.props || null },
      ];
      setTabList(updated_tabs);
      setSelectedIndex(updated_tabs.length - 1);
      setAddNewTab(null);
    }
  }, [SET_MAXIMUM_TABS, addNewTab, selectedIndex, setAddNewTab, tabs]);

  useEffect(() => {
    const req_interceptor = nodeClient.interceptors.request.use((req) => {
      req.headers = {
        ...req.headers,
        token: sessionStorage.getItem("token"),
      };
      return req;
    });
    const res_interceptor = nodeClient.interceptors.response.use(
      (response) => {
        if (response?.data?.error === 401) {
          return logoutHandler();
        }
        if (BYPASS_ERROR_URLS.indexOf(response?.config.url) !== -1) {
          setShowLoading(false);
          return response;
        }
        if (response?.data?.status !== "success") {
          displayToast({
            type: "error",
            title:
              typeof response?.data?.result === "string"
                ? response?.data?.result
                : typeof response?.data?.result === "object" &&
                  (response?.data?.result?.message ||
                    "An unexpected error occured"),
          });
          return setShowLoading(false);
        }
        setShowLoading(false);
        return response;
      },
      (error) => {
        displayToast({
          type: "error",
          title: "Something went wrong! Please try again later.",
        });
        setShowLoading(false);
      }
    );
    return () => {
      nodeClient.interceptors.response.eject(res_interceptor);
      nodeClient.interceptors.response.eject(req_interceptor);
    };
  }, [logoutHandler, setShowLoading]);

  return (
    <>
      <Loading open={showLoading} />
      <div className={classes["home"]}>
        <Tab
          tabs={tabList}
          goToNextTab={nextTab}
          goToPrevTab={prevTab}
          closeCurrentTab={closeTab}
          focusTabIndex={selectedIndex}
          closeTab={closeTabHandler}
          tabClicked={(index) => {
            setNextTab(false);
            setPrevTab(false);
            setSelectedIndex(index);
            dispatch({ type: "update_active_tab_index", payload: index });
          }}
          updatedTabs={updatedTabsHandler}
          variant="filled"
          titleBarStartItems={titleBarStartItems}
          enableTabSummary={true}
          titleBarEndItems={titleBarEndItems}
          closeTriggered={(params) => {
            setCloseTab(false);
            if (params?.triggered) {
              setCurrentComponent("common-modal");
            } else {
              setCurrentComponent(null);
            }
          }}
        />
      </div>
      {showSpotlight && <Spotlight />}
    </>
  );
};

export default Home;
